import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {DeliveriesService} from "../../../deliveries/services/deliveries-service.service";
import {SplitService} from "../../../commons/services/split-service.service";

export class deliveryQuoteSelectCtrl implements IController {

  delivery: any;
  dateOptions: any;
  selectedDate: any;
  quoteOptions: any;
  selectedQuote: any;
  addressZoneId: string;
  onDateChange: Function;
  onSelectedQuoteChange: Function;

  private urgencyTimeWindows: any;
  private urgencyQuoteOptions: any;
  private timeSlotQuoteOptions: any;
  private dynamicTimeSlotQuoteOptions: any;
  private minDate: any;
  private maxDate: any;
  private quoteType: any;
  private configZoneId: string;
  private freeStyleSelectedQuoteMin: any;
  private freeStyleSelectedQuoteMax: any;

  /* @ngInject */
  constructor(private deliveriesService: DeliveriesService, private splitService: SplitService) {
    this.onlyValidPredicate = this.onlyValidPredicate.bind(this);
  }

  $onInit() {
    this.minDate = new Date(_.min(this.dateOptions));
    this.maxDate = new Date(_.max(this.dateOptions));
    this.configZoneId = this.splitService.getTimeZone();

    if (this.selectedQuote) {
      this._setNewQuote(this.selectedQuote, this.quoteOptions);
    }
  };

  $onChanges(changes) {
    if (changes.dateOptions && !changes.dateOptions.isFirstChange()) {
      this.$onInit();
    }

    if (changes.selectedQuote && !changes.selectedQuote.isFirstChange()) {
      if (this.selectedQuote) {
        this._setNewQuote(this.selectedQuote, this.quoteOptions);
      }
    }
  };

  // ******************************
  //        Public methods
  // ******************************

  onlyValidPredicate(date) {
    return !!_.filter(this.dateOptions, (day) => {
      return this._sameDay(new Date(day), date);
    }).length;
  }

  getQuoteTypes(quotes) {
    return _.chain(quotes)
      .map((q) => {
        return q.type;
      })
      .uniq()
      .value();
  }

  onQuoteTypeChanged(quoteType) {
    const changeToQuote = _.find(this.quoteOptions, (q) => {
      return q.type === quoteType
    });
    this.freeStyleSelectedQuoteMin = undefined;
    this.freeStyleSelectedQuoteMax = undefined;
    if (quoteType === 'FreeStyle' && changeToQuote) {
      this.freeStyleSelectedQuoteMin = changeToQuote.startTime;
      this.freeStyleSelectedQuoteMax = changeToQuote.endTime;
    }
    this.onSelectedQuoteChange({quote: changeToQuote});
  }

  onUrgencyChanged(selectedQuote) {
    this.urgencyTimeWindows = this._getUrgencyQuoteTimeWindows(selectedQuote);

    if (this.urgencyTimeWindows.length) {
      selectedQuote.defaultStartTime = selectedQuote.startTime;
      selectedQuote.defaultEndTime = selectedQuote.startTime + selectedQuote.duration;
    }

    this._setQuoteToDelivery(selectedQuote);
  }

  onQuoteTimeChanged(from, to, selectedTimeSlotQuote) {
    this._setQuoteToDelivery(selectedTimeSlotQuote, from, to);
  }

  onFreeStyleQuoteTimeChanged(from, to) {
    this._setQuoteToDelivery(this.selectedQuote, from, to);
  }

  onQuoteTimeChangedPerTask(from, to, taskIndex) {
    if (taskIndex === 0) {
      this.delivery.notBefore = from;
    } else {
      this.delivery.notAfter = to;
    }
  }

  // ******************************
  //        Private methods
  // ******************************

  _setNewQuote(quote, quoteOptions) {
    this.quoteType = quote.type;
    if (quote.type === 'PerTask') {
      this._setQuoteToDeliveryPerTask(quote)
    } else {
      this.urgencyTimeWindows = _.isEqual(quote.type, 'Urgency') ? this._getUrgencyQuoteTimeWindows(quote) : [];
      this.urgencyQuoteOptions = this._getUrgencyQuoteOptions(quoteOptions);
      this.timeSlotQuoteOptions = this._getTimeSlotQuoteOptions(quoteOptions);
      this.dynamicTimeSlotQuoteOptions = this._getDynamicTimeSlotQuoteOptions(quoteOptions);
      if (!quote.defaultStartTime) {
        quote.defaultStartTime = quote.startTime;
      }
      if (!quote.defaultEndTime) {
        quote.defaultEndTime = quote.startTime + quote.duration;
      }
      if (!quote.endTime) {
        quote.endTime = quote.startTime + quote.duration;
      }
      this._setQuoteToDelivery(quote);
    }
  }

  _getUrgencyQuoteTimeWindows(selectedQuote) {

    if (selectedQuote.type !== 'Urgency') {
      return [];
    }

    const selectedQuoteCopy = angular.copy(selectedQuote);

    const timeWindowQuotes = [];
    let startTime = selectedQuote.startTime;
    const step = selectedQuote.minStep;

    while (startTime <= selectedQuoteCopy.maxStartTime) {
      selectedQuoteCopy.startTime = startTime;
      timeWindowQuotes.push(angular.copy(selectedQuoteCopy));
      startTime += step;
    }

    return timeWindowQuotes;
  }

  _setQuoteToDelivery(selectedQuote?, from?, to?) {
    this.deliveriesService.updateDeliveryQuote(this.delivery, selectedQuote, from, to);
  }

  _setQuoteToDeliveryPerTask(quote) {
    this.deliveriesService.updateDeliveryQuotePerTask(
      this.delivery,
      quote.quotes[0].defaultStartTime,
      quote.quotes[0].defaultEndTime,
      quote.quotes[1].defaultStartTime,
      quote.quotes[1].defaultEndTime,
      quote.quotes[0].defaultVehicleType)

  }

  _sameDay(d1, d2) {
    return d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();
  }

  _getUrgencyQuoteOptions(quotes) {
    return _.filter(quotes, (q) => {
      return q.type === 'Urgency'
    })
  }

  _getTimeSlotQuoteOptions(quotes) {
    return _.filter(quotes, (q) => {
      return q.type === 'TimeSlot'
    })
  }

  _getDynamicTimeSlotQuoteOptions(quotes) {
    return _.filter(quotes, (q) => {
      return q.type === 'DynamicTimeSlot'
    })
  }

}

angular
  .module('bringoz.admin.orders')
  .component('deliveryQuoteSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      delivery: '<',
      dateOptions: '<',
      selectedDate: '<',
      quoteOptions: '<',
      selectedQuote: '<',
      addressZoneId: '<',
      onDateChange: '&',
      onSelectedQuoteChange: '&'
    },
    template: require('./delivery-quote-select.html').default,
    controller: deliveryQuoteSelectCtrl
  });
